import { defineMessages } from "react-intl";

export const messages = defineMessages({
	name: {
		id: "dashboard.name",
		defaultMessage: "Páciens neve"
	},
	statementOfConsentAlert: {
		id: "dasboard.statement_of_consent_alert",
		defaultMessage:
			"A páciens beleegyező nyilatkozata nem került feltöltésre!"
	},
	status: {
		id: "dashboard.status",
		defaultMessage: "Státusz"
	},
	ssn: {
		id: "dashboard.social_security_number",
		defaultMessage: "TAJ"
	},
	address: {
		id: "dashboard.address",
		defaultMessage: "Lakhely"
	},
	phoneNumber: {
		id: "dashboard.phone_number",
		defaultMessage: "Telefon"
	},
	bloodGroup: {
		id: "dashboard.blood_group",
		defaultMessage: "Vércsoport"
	},
	age: {
		id: "dashboard.age",
		defaultMessage: "Életkor"
	},
	weight: {
		id: "dashboard.weight",
		defaultMessage: "Testsúly"
	},
	height: {
		id: "dashboard.height",
		defaultMessage: "Magasság"
	},
	bmi: {
		id: "dashboard.bmi",
		defaultMessage: "BMI"
	},
	dashboard: {
		id: "dashboard.dashboard",
		defaultMessage: "Dashboard"
	},
	editPatient: {
		id: "dashboard.edit_patient",
		defaultMessage: "Páciens adatainak szerkesztése"
	},
	timeline: {
		id: "dashboard.timeline",
		defaultMessage: "Idővonal"
	},
	report: {
		id: "dashboard.report",
		defaultMessage: "Riport"
	}
});
